const NEIGHBORS_SCAN_FAILURE_STATUSES = new Set(['failed_to_send', 'failed_to_store']);

export const countNeighborsScanFailures = (results = []) =>
  results.filter((r) => NEIGHBORS_SCAN_FAILURE_STATUSES.has(r.status)).length;

export const summarizeNeighborsScanBatch = (resp, requestedCount) => {
  const results = resp?.results || [];
  const accepted = resp?.commands_sent ?? 0;
  const failed = countNeighborsScanFailures(results);
  const skipped = results.filter((r) => r.status === 'skipped' || r.status === 'not_found').length;
  return {
    accepted,
    failed,
    skipped,
    targeted: resp?.devices_targeted ?? requestedCount,
  };
};
